import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const UserEditPage_v2 = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState({
    username: "",
    email: "",
    first_name: "",
    last_name: "",
  });

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/admin/users/${username}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      setUser(response.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BASE_URL}/admin/users/${username}`, user, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authentication/token")}`,
        },
      });
      Swal.fire("Success!", "User updated successfully.", "success");
      navigate("/users");
    } catch (error) {
      Swal.fire("Error!", "Failed to update user.", "error");
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <h1 className="text-2xl font-bold mb-4">Edit User</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Username</label>
          <input
            type="text"
            value={user.username}
            onChange={(e) => setUser({ ...user, username: e.target.value })}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            value={user.email}
            onChange={(e) => setUser({ ...user, email: e.target.value })}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">First Name</label>
          <input
            type="text"
            value={user.first_name}
            onChange={(e) => setUser({ ...user, first_name: e.target.value })}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Last Name</label>
          <input
            type="text"
            value={user.last_name}
            onChange={(e) => setUser({ ...user, last_name: e.target.value })}
            className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm"
          />
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded-md"
        >
          Update
        </button>
        <button
          type="button"
          onClick={() => navigate("/users")}
          className="ml-2 bg-gray-500 text-white px-4 py-2 rounded-md"
        >
          Back
        </button>
      </form>
    </div>
  );
};

export default UserEditPage_v2;